exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-page .wrapper-main .list-items-container ul{display:block;padding-left:30px;padding-top:10px;width:100%;color:#545454}.info-page .wrapper-main .list-items-container ul li{text-align:left;margin-left:25px;font-size:14px;display:list-item;list-style-type:disc;max-width:500px}.info-page.terms .wrapper-main .container p{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/home/home.css
// module id = 616
// module chunks = 0